module.exports = () => ({ contains: [], disableAutodetect: true, name: 'Plain text' });
